/* eslint-disable no-param-reassign */
import getFeature from "./getFeature";
// example of needed domains , note that the name is your resulted object key
// neededDomains: [{ layerId: esriUrls.url, name: "lookupName" }]
export default async function getExternalDomains({ neededDomains, token }) {
  //   const features = [];
  const domainsPromises = [];
  const domains = {};
  //  create promises since i cant use await async inside a loop
  //  so I prepared an array of promises to use await on it then map on its response
  for (let index = 0; index < neededDomains.length; index += 1) {
    const { layerId } = neededDomains[index];
    const lookupsUrl = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${
      process.env.REACT_APP_PETRASOLAR_SERVICE
    }/MapServer/${layerId}?${token ? `&token=${token}` : ""}`;
    domainsPromises.push(getFeature(lookupsUrl));
  }
  const domainsRes = await Promise.all(domainsPromises);
  domainsRes.forEach((domainRes, idx) => {
    // give each object the right needed domain name
    domains[neededDomains[idx].name] = domainRes.map(({ attributes }) => {
      // rename the properties to match esri domains request
      attributes.code = attributes.CODE;
      attributes.name = attributes.DESCRIPTION;
      delete attributes.CODE;
      delete attributes.DESCRIPTION;
      delete attributes.OBJECTID;
      return attributes;
    });
  });
  return domains;
}
